import { render, staticRenderFns } from "./GuppyChatMessagesContainer.vue?vue&type=template&id=01f7893c&scoped=true&"
import script from "./GuppyChatMessagesContainer.vue?vue&type=script&lang=js&"
export * from "./GuppyChatMessagesContainer.vue?vue&type=script&lang=js&"
import style0 from "./GuppyChatMessagesContainer.vue?vue&type=style&index=0&id=01f7893c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f7893c",
  null
  
)

export default component.exports